<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
    name: 'finishedInputs',
    props: {
        value: {
            type: Object
        }
    },
    computed: {
        ...mapGetters(['authGetUser'])
    },
    data: () => {
        return {
            workingData: {
                
            }
        }
    },
    beforeMount(){
        this.workingData = _.clone(this.value)
    }
}
</script>

<template>
    <div id="finished-inputs">

        <b-input-group append="Pedido" prepend="$">
            <b-form-input v-model="workingData.costo_pedido" disabled></b-form-input>
        </b-input-group>

        <template v-if="authGetUser.tipoUsuario == 'Admin'">

            <b-input-group append="Abatimiento" prepend="$" class="mt-3 mb-3">
                <b-form-input v-model="workingData.costo_abatimiento" disabled></b-form-input>
            </b-input-group>

            <b-input-group append="Operativo" prepend="$">
                <b-form-input :value="(parseFloat(workingData.costo_produccion_horachef) + parseFloat(workingData.costo_produccion_gasagualuz)).toFixed(2)" disabled></b-form-input>
            </b-input-group>
            
        </template>

        <!-- <pre>{{workingData}}</pre> -->
    </div>
</template>

<style lang="less">
    #finished-inputs {

    }
</style>